var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelebrityPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 56,
    viewBox: "0 0 46 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9194 53.3797L22.6238 54.0895L23.3281 53.3797L38.2246 38.3671C46.4356 30.092 46.4356 16.6756 38.2246 8.40058C30.0136 0.125566 16.701 0.12557 8.48996 8.40058L8.12321 8.7702C-0.290335 17.2493 -0.290327 30.9968 8.12321 39.4759L21.9194 53.3797Z",
    fill: "#1CB5E7",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3858 3.22168C17.5882 3.45495 12.8579 5.41783 9.19399 9.11032L8.82724 9.47993C0.8027 17.567 0.802706 30.6788 8.82724 38.7659L22.3858 52.4302V3.22168Z",
    fill: "#56CCF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24C7 15.1634 14.1634 8 23 8C31.8366 8 39 15.1634 39 24C39 32.8366 31.8366 40 23 40C14.1634 40 7 32.8366 7 24Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 32.151L20.6976 23.7194L13.734 16H18.9971L23.3663 20.7959L27.7452 16H33.0203L26.0364 23.7256L33.7139 32.151H28.3041L23.3678 26.6781L18.4201 32.151H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrityPin);
export default __webpack_public_path__ + "static/media/celebrity-pin.ce6dd5982c825f136f57c3cc32fa527a.svg";
export { ForwardRef as ReactComponent };